import { $themeBreakpoints } from '@themeConfig'
import axiosIns from '@/libs/axios'
import io from 'socket.io-client';

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    onlineUsers: [],
    salaryRecordOptions: [],
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_ONLINE_USERS(state, users) {
      state.onlineUsers = users;
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    SET_SALARY_RECORD_OPTIONS(state, options) {
      state.salaryRecordOptions = options;
    }
  },
  actions: {
    fetchOptionList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/options/',{params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    checkUserNameCn(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/check/name_cn', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    checkUserName(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/check/name', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    checkUserPhone(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/check/phone', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    checkUserEmail(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/check/email', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchUserInfo(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/user-info', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    connectSocket({ commit, state }, data) {
      console.log('connectSocket', data)
    const socket = io('http://localhost:18888');

      // 发送当前用户上线的訊息
      socket.emit('online', data);

      // 监听在线用户列表的变化
      socket.on('online-users', (users) => {
        commit('SET_ONLINE_USERS', users);
      });

      // 处理组件销毁时的 socket 断开连接
      this._vm.$once('hook:beforeDestroy', () => {
        socket.disconnect();
      });
    },
    getUserCoupon(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/coupons/getUserCoupon", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    getUserGiftVoucher(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/gift_vouchers/getUserGiftVoucher", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchRoles(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/roles/list',{params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    agreeToTerms(ctx, data){
      return new Promise((resolve, reject) => {
        axiosIns.post('/agree-to-terms', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchProjectUsers(ctx, id){
      return new Promise((resolve, reject) => {
        axiosIns.get(`/projects/${id}/users`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchUserProjects(ctx, id){
      return new Promise((resolve, reject) => {
        axiosIns.get(`/${id}/projects`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchSettingInfo(ctx, id){
      return new Promise((resolve, reject) => {
        axiosIns.get(`/settings/settings/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    editSettingInfo(ctx, data) {
      return new Promise((resolve, reject) => {
          axiosIns.post('/settings/settings', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editUserAvatar(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('/user-image', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchAvatars(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/settings/user-images', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    editAvatar(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('/settings/user-images', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    deleteAvatar(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/settings/user-images', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    cleanLocked(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('/reset-lock-status', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchSalaryRecords(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/user/salary_records', { params: queryParams })
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchSalaryRecordOptions({ commit }) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/options/', { params: { salary_records: true } })
          .then(response => {
            if (response.data && response.data.salary_records) {
              commit('SET_SALARY_RECORD_OPTIONS', response.data.salary_records);
            }
            resolve(response);
          })
          .catch(error => reject(error));
      });
    },
  },
}
